import React from 'react';
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath, useReactFlow } from '@xyflow/react';
import { X } from 'lucide-react';

/* Wire with a label chip and a one-click detach (×) button. Each branch
   from the same step gets its own horizontal lane so wires never overlap. */
export default function FlowEdge({ id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, style, data, selected }) {
  const { deleteElements } = useReactFlow();
  const lane = data?.lane || 0;
  const centerY = targetY > sourceY + 40 ? Math.min(sourceY + 28 + lane * 12, targetY - 16) : undefined;
  const [path] = getSmoothStepPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition, borderRadius: 14, offset: 20, centerY });
  const color = data?.color || '#2dd4bf';
  const [lx, ly] = [targetX, targetY - 36];
  return (
    <>
      <BaseEdge id={id} path={path} style={style} interactionWidth={24} />
      <EdgeLabelRenderer>
        <div className="nodrag nopan absolute group flex items-center gap-1" style={{ transform: `translate(-50%, -50%) translate(${lx}px, ${ly}px)`, pointerEvents: 'all', zIndex: 1001, opacity: style?.opacity ?? 1 }}>
          {data?.label && (
            <span className="px-1.5 py-0.5 rounded text-[9px] font-bold uppercase tracking-wider border" style={{ color, borderColor: `${color}55`, background: 'var(--vox-label-bg)' }}>
              {data.label}
            </span>
          )}
          <button type="button" onClick={(e) => { e.stopPropagation(); deleteElements({ edges: [{ id }] }); }}
            className={`${selected ? 'flex' : 'hidden group-hover:flex'} w-4 h-4 rounded-full bg-rose-500 text-white items-center justify-center shadow`}
            title="Detach" data-testid={`edge-detach-${id}`}>
            <X size={10} />
          </button>
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
